import LegalPage from "./LegalPage";
import {
  RISK_DISCLOSURE,
  PRIVACY_POLICY,
  TERMS,
  PERFORMANCE_METHODOLOGY,
  CUSTODY,
  FEES_TERMS,
} from "../content/legal";

export function RiskDisclosurePage() {
  return <LegalPage content={RISK_DISCLOSURE} path="/risk-disclosure" />;
}
export function PrivacyPolicyPage() {
  return <LegalPage content={PRIVACY_POLICY} path="/privacy-policy" />;
}
export function TermsPage() {
  return <LegalPage content={TERMS} path="/terms-and-conditions" />;
}
export function PerformanceMethodologyPage() {
  return <LegalPage content={PERFORMANCE_METHODOLOGY} path="/performance-methodology" />;
}
export function CustodyPage() {
  return <LegalPage content={CUSTODY} path="/custody-and-asset-handling" />;
}
export function FeesTermsPage() {
  return <LegalPage content={FEES_TERMS} path="/fees-and-product-terms" />;
}